<template>
    <div class="create u-p1">
        <div class="row u-mb2">
              <div class="col-sm">
                <label for="exampleInputEmail1">Form Name</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text"><i class="fas fa-pencil-alt prefix"></i></div>
                  </div>
                  <input class="form-control" placeholder="Please enter a name for this form" id="form_name" type="text">
                </div>
                <small id="emailHelp" class="form-text text-muted">Please add a name for this form</small>
              </div>

              <div class="col-sm">
                  <label for="exampleInputEmail1">Contact Email</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text"><i class="fas fa-pencil-alt prefix"></i></div>
                    </div>
                    <input class="form-control" placeholder="Please enter a recipient for this form" id="form_email" type="email">
                  </div>
                  <small id="emailHelp" class="form-text text-muted">Enter a contact email address for this form</small>
             </div>
        </div>

        <div class="row" v-if="$root.user_type == 'rocket'">
          <div class="col-sm">
            <div class="form-group form-check">
              <input type="checkbox" class="form-check-input" id="data_capture" checked>
              <label class="form-check-label" for="data_capture">Show data capture form?</label>
            </div>
          </div>
        </div>

        <div class="row">
              <div class="col-sm">
                <div class="horizontal">
                  <div class="card-stacked">
                    <div class="card-content">
                       <form action="" id="form-builder-pages">
                          <ul id="tabs">
                            <li><a href="#page-1">Page 1</a></li>
                            <li id="add-page-tab"><a href="#new-page">+ Page</a></li>
                          </ul>
                          <div id="page-1" class="fb-editor"></div>
                          <div id="new-page"></div>
                        </form>
                        <br>
                      <div class="save-all-wrap right">

                        <button id="save-all" class="btn btn-primary text-light u-full-width" type="button"><i class="fas fa-save"></i> Save Form</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
    </div>
</template>

<script>


import {alerts} from '@/mixins/alerts.js';

export default {
    name: 'create',
    data : function () {
        return {
            profile:{},
            loading:true
        };
    },
    mounted : function () {
        let self = this;

          let mappingField = {
              mapping: {
                  label: 'Maps to?',
                  value: '',
              }
          };
          var options = {
            fields : [{
              label: 'Signable',
              type: 'signable',
              icon: "<center><b>S</b></center>"
            },
            {
              label: 'Horizontal Rule',
              type: 'line',
              icon: "<center><b>-</b></center>"
            }],
            templates : {
              signable: function(fieldData) {
                return {
                  field: '<span id="'+fieldData.name+'">',
                  onRender: function() {
                    fieldData.className = 'form-control';
                    let help = fieldData.description
                    if(help == undefined){
                      help = 'Add your help text here...';
                    }
                    $('#'+this.config.name).html('<div style="border:1px dashed #9b9b9b;height:80px;color:#9b9b9b;padding: 1em;text-align: center;"></div><p style="text-align:center;"><small>'+help+'</small></p>')
                  }
                };
              },
              line: function(fieldData) {
                return {
                  field: '<span id="'+fieldData.name+'">',
                  onRender: function() {
                    fieldData.value = '<hr>';
                    $('#'+this.config.name).html('<div><hr></div>')
                  }
                };
              }
            },
            showActionButtons: false,
            controlPosition: 'left',
            disabledAttrs: ['access','className','name','toggle','inline','other','multiple','max','maxlength','rows', 'value'],
            disableFields: ['autocomplete','number','button','hidden'],
            disabledSubtypes: {
              text: ['password','color'],
              textarea: ['tinymce','quill'],
            },
            disabledFieldButtons : {
              'text': ['copy'],
              'signable': ['copy'],
              'line': ['copy','edit'],
              'checkbox-group': ['copy'],
              'date': ['copy'],
              'file': ['copy'],
              'header': ['copy'],
              'number': ['copy'],
              'paragraph': ['copy'],
              'radio-group': ['copy'],
              'select': ['copy'],
              'text': ['copy'],
              'textarea': ['copy']
            },
            typeUserAttrs: {
                text: mappingField,
                signable: mappingField,
                date: mappingField,
                file: mappingField,
                number : mappingField,
                select : mappingField,
                textarea: mappingField,
                'checkbox-group': mappingField,
                'radio-group': mappingField,
            }
          };



          jQuery($ => {
            var $tabUL = $('#tabs'),
            $formPages = $('#form-builder-pages'),
            $newPage = $('#new-page'),
            $newPageLink = $('#add-page-tab'),
            countFB = 1,
            fbEditor = [$('#page-1').formBuilder(options)];

            $newPageLink.click(function () {
                countFB++;
                $newPageLink.before(`<li><a href="#page-${countFB}">Page ${countFB}</a></li>`);
                $newPage.before(`<div id="page-${countFB}" class="fb-editor"></div>`)
                $formPages.tabs('refresh');
                var x = countFB - 1;
                $formPages.tabs('option', 'active', x);
                fbEditor.push($(`#page-${countFB}`).formBuilder(options));
            });

            $formPages.tabs({
                beforeActivate: function (event, ui) {
                    if (ui.newPanel.selector === "#new-page") {
                        return false;
                    }
                }
            });

            $(document.getElementById("save-all")).click(function() {
              const allData = fbEditor.map(fb => {
                // console.log(JSON.stringify(fb.actions.getData()));
                return JSON.stringify(fb.actions.getData());
              });
              // console.log(JSON.stringify(allData));
              // send to save
              if($('#form_name').val() == '' || $('#form_email').val() == '')
              {
               self.errorMsg('Please select a name and recipient for this form');
                return !1
              }
              let params={
                user_id : self.business_id,
                forms: allData,
                title: $('#form_name').val(),
                email: $('#form_email').val()
              };

              if (self.$root.user_type == 'rocket') {
                params.data_capture = $('#data_capture').prop("checked") == true;
              }

              // self.axios.defaults.headers.common['Authorization'] = self.$root.user_id;
              self.axios.post(self.$root.env_url+'/api/v1/form/forms', params)
              .then(response => {
                  self.successMsg(response.data.message);
                  self.$router.push({name : 'index'});
              })
              .catch(error => {

                self.errorMsg('Error - we could not save the form')
                console.error('error saving form', error);
              });
            });

          });



    },
    components: {},
    methods:{},
    watch : {}
}
</script>

<style lang="scss">

@import '../sass/variables.scss';

.ui-state-active, .ui-widget-content .ui-state-active, .ui-widget-header .ui-state-active, a.ui-button:active, .ui-button:active, .ui-button.ui-state-active:hover {



}
.fld-description{

}
.option-label, .option-value{

}
.option-label{
    // display: none;
}

.option-value{
    // width:95% !important;
}
.frm-holder{

}

.form-wrap.form-builder .form-control {

}


</style>
